module.exports = __webpack_public_path__ + "static/zwyzka-nozycowa-huta-stalowa-wola-5bc701450b88935bbffee14fa827d331.jpg";